
function Logout() {
  return (
    <div className="pt-32">
      <h1>See ya later!</h1>
    </div>
  );
}
export default Logout;
